"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ComboBoxImplementation = exports.ComboBox = exports.ComboBoxItem = exports.ComboBoxDropDown = exports.ComboBoxInput = exports.ComboBoxListWrapper = exports.ComboBoxButtonWrapper = exports.ComboBoxButton = exports.ComboBoxListSubheader = exports.useComboBoxContext = exports.ComboBoxContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = _interopRequireDefault(require("@eig-builder/core-ui/List"));

var _ListSubheader = _interopRequireDefault(require("@eig-builder/core-ui/ListSubheader"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _usePrevious = _interopRequireDefault(require("@eig-builder/core-utils/hooks/usePrevious"));

var _xor = _interopRequireDefault(require("lodash/xor"));

var _footer = require("./footer");

var _implementation = _interopRequireDefault(require("./implementation"));

var _input = _interopRequireDefault(require("./input"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

var _item = _interopRequireDefault(require("./item"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 480px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledList = (0, _styledComponents["default"])(_List["default"])(_templateObject());
var ComboBoxContext = (0, _react.createContext)({});
exports.ComboBoxContext = ComboBoxContext;

var useComboBoxContext = function useComboBoxContext() {
  var context = (0, _react.useContext)(ComboBoxContext);

  if (!context) {
    throw new Error('No context found for useComboBoxContext');
  }

  return context;
};

exports.useComboBoxContext = useComboBoxContext;

var ComboBoxRoot = function ComboBoxRoot(_ref) {
  var children = _ref.children,
      multi = _ref.multi,
      onChange = _ref.onChange,
      value = _ref.value;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var previous = (0, _usePrevious["default"])(selected);

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      anchorRef = _useState6[0],
      setAnchorRef = _useState6[1];

  if (multi && !Array.isArray(value)) {
    throw new Error('Multi option requires array values in the combo box');
  } // Set the selected value to the default one


  _react["default"].useEffect(function () {
    if (!selected && value) {
      setSelected(value);
    }
  }, [value, selected]); // 📤 notify the upper component that we have changed!


  _react["default"].useEffect(function () {
    if (!(previous === null && selected === null) && previous !== selected) {
      onChange(selected);
      setOpen(false);
    }
  }, [onChange, previous, selected]);

  var checkForSelectedItem = function checkForSelectedItem(value) {
    return multi ? selected.includes(value) : selected === value;
  };

  var selectItem = function selectItem(value) {
    return setSelected(multi ? (0, _toConsumableArray2["default"])((0, _xor["default"])(selected, [value])) : value);
  };

  return /*#__PURE__*/_react["default"].createElement(ComboBoxContext.Provider, {
    value: {
      open: open,
      setOpen: setOpen,
      anchorRef: anchorRef,
      setAnchorRef: setAnchorRef,
      selected: selected,
      setSelected: setSelected,
      selectItem: selectItem,
      multi: multi,
      checkForSelectedItem: checkForSelectedItem
    }
  }, children);
};

ComboBoxRoot.propTypes = {
  children: _propTypes["default"].node.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  multi: _propTypes["default"].bool,
  value: _propTypes["default"].any
};

var ComboBoxListSubheader = function ComboBoxListSubheader(_ref2) {
  var actionArea = _ref2.actionArea,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["actionArea"]);
  return /*#__PURE__*/_react["default"].createElement(_ListSubheader["default"], {
    disableSticky: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    className: "py-3",
    color: "textPrimary",
    variant: "h5",
    style: {
      position: 'relative',
      display: 'inline'
    }
  }, rest)), actionArea);
};

exports.ComboBoxListSubheader = ComboBoxListSubheader;
ComboBoxListSubheader.propTypes = {
  actionArea: _propTypes["default"].node
};
var ComboBoxButton = _footer.DropdownFooterButton;
exports.ComboBoxButton = ComboBoxButton;
var ComboBoxButtonWrapper = _footer.DropdownFooter;
exports.ComboBoxButtonWrapper = ComboBoxButtonWrapper;
var ComboBoxListWrapper = StyledList;
exports.ComboBoxListWrapper = ComboBoxListWrapper;
var ComboBoxInput = _input["default"];
exports.ComboBoxInput = ComboBoxInput;
var ComboBoxDropDown = _dropdown["default"];
exports.ComboBoxDropDown = ComboBoxDropDown;
var ComboBoxItem = _item["default"];
exports.ComboBoxItem = ComboBoxItem;
var ComboBox = ComboBoxRoot;
exports.ComboBox = ComboBox;
var ComboBoxImplementation = _implementation["default"];
exports.ComboBoxImplementation = ComboBoxImplementation;
var _default = ComboBoxRoot;
exports["default"] = _default;